import "./Input.module.scss";

const Input = ({ label, placeholder, aoAlterado, value, className, tipo = "text"}) => {
  const aoDigitado = (evento) => {
    aoAlterado(evento.target.value)
  }  

  return (
    <div>
      <label>{ label }</label>
      <input 
        className={className}
        placeholder={ placeholder }
        onChange={aoDigitado}
        value={value}        
        type={tipo}
       />       
    </div>
    
  )
}

export default Input;
  